import { EventTypes, UnpopulatedEvent } from '../../utils/types';

interface SimpleUser {
    id: string;
    username: string;
    avatarUrl: string;
    averageRating: number;
}

export interface Feed {
    id: string;
    type: FeedTypes;
    createdAt: string;
    user: SimpleUser;
    sportEvent?: {
        id: string;
        name: string;
        date: Date;
        owner: SimpleUser;
        place: string;
        type: EventTypes;
    };
    follower?: SimpleUser;
}

export enum FeedTypes {
    CREATE_EVENT = 'CREATE_EVENT',
    JOIN_EVENT = 'JOIN_EVENT',
    FOLLOW = 'FOLLOW',
}

export interface UserEvents {
    nextEvents: UnpopulatedEvent[];
    awaitingVoteEvents: UnpopulatedEvent[];
}
